import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { getLanTypeFromUrl, returnType } from '@/utils';
import { saveLangAndCurrency } from "../utils";

Vue.use(VueI18n)

/** 本地存储语言类型和货币类型 */
saveLangAndCurrency();

const DEFAULT_LANG = returnType(window.localStorage.getItem('lan_type')) || 'zh_cn';
const LOCALE_KEY = 'lan_type'

const locales = {
  zh_cn: require('./zh_cn.js'),
  ja_jp: require('./ja_jp.js'),
  zh_hk: require('./zh_hk.js'),
  en_us: require('./en_us.js'),
  ko_kr: require('./ko_kr.js'),
  th_th: require('./thai.js'),
  de_de: require('./german.js'),
  fr_fr: require('./french.js'),
  es_es: require('./spain.js'),
  sv_se: require('./swedish.js'),
  nl_nl: require('./dutch.js'),
  vi_vn:require('./vietnamese.js'),
  ms_my:require('./malay.js'),
  id_id:require('./indo.js')
}

const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales,
})

export const setup = lang => {
  if (lang === undefined) {
    lang = returnType(window.localStorage.getItem(LOCALE_KEY))
    if (locales[lang] === undefined) {
      lang = DEFAULT_LANG
    }
  }
  // window.localStorage.setItem(LOCALE_KEY, lang)

  Object.keys(locales).forEach(lang => {
    document.body.classList.remove(`lang-${lang}`)
  })
  document.body.classList.add(`lang-${lang}`)
  document.body.setAttribute('lang', lang)

  Vue.config.lang = lang
  i18n.locale = lang
}

setup()
export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js